import Shop from '../shop';

export default class Bakery extends Shop {
    /**
     *
     */
    constructor() {
        super({
            name:                 'Bakery',
            id:                   'Bakery',
            coolDown:             180,
            faClass:              'fa-birthday-cake',
            individualCostFactor: 1.135,
            baseEarnings:         51840.0,
            baseCosts:            103680.0,
            grade:                5
        });
    }
}
